import { render, staticRenderFns } from "./report-rfm.vue?vue&type=template&id=770ebeba&scoped=true"
import script from "./report-rfm.vue?vue&type=script&lang=js"
export * from "./report-rfm.vue?vue&type=script&lang=js"
import style0 from "./report-rfm.vue?vue&type=style&index=0&id=770ebeba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770ebeba",
  null
  
)

export default component.exports